"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JrpcSocket = void 0;
const core_1 = __importDefault(require("../../core"));
const { nekoton, fetch } = core_1.default;
class JrpcSocket {
    async connect(clock, params) {
        class JrpcSender {
            constructor(params) {
                this.endpoint = params.endpoint;
                this.alternativeEndpoint = params.alternativeEndpoint != null
                    ? params.alternativeEndpoint
                    : params.endpoint;
            }
            send(data, handler, requiresDb) {
                ;
                (async () => {
                    try {
                        const response = await fetch(requiresDb ? this.endpoint : this.alternativeEndpoint, {
                            method: 'post',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: data,
                        }).then((response) => response.text());
                        handler.onReceive(response);
                    }
                    catch (e) {
                        handler.onError(e);
                    }
                })();
            }
        }
        return new nekoton.JrpcConnection(clock, new JrpcSender(params));
    }
}
exports.JrpcSocket = JrpcSocket;
